import React, { useContext, useEffect, useState } from "react";
import SelectField from "../../../commonfields/SelectField";
import stateNames from "../../../data/stateNames.json";
import { Col, Container } from "reactstrap";
import { Field, getFormValues, reduxForm } from "redux-form";
import { connect } from "react-redux";
import Service from "../../../services";
import { AxiosError } from "axios";
import { State } from "./LeadDetails";
import AddNewContactCards from "../../procpectingDetailPge/AddNewContactCards";
import { BankUserContext } from "../../../bankUserContext";

const SelectExistingContact = (props: any) => {
  const { editLeadData, productId } = props
  const service = new Service();
  const [leadData, setLeadData] = useState([]);
  const [searchVal, setSearchVal] = useState<string>("");
  const [contactsList, setContactsList] = useState([]);
  const context = useContext(BankUserContext)

  useEffect(() => {
    // console.log(searchVal);
    getAddContact();
  }, []);

  const handleSearch = (value: string) => {
    setSearchVal(value);
  };

  const handleSelectContact = (id: string, isPrimary: boolean) => {
    if (props.formValues !== undefined) {
      props.handleSelect(id, isPrimary, leadData, props.businessName, props?.parentClientId, props?.clientId);
    }
  };
  const getAddContact = (search = "") => {

    if (props?.clientId) {
      let payload = {
        orgId: context.bankuserDetails?.organization.orgId,
        screen: "ProspectDetails",
        sections: "GetClientContacts",
        clientId: props?.clientId,
        parentClientId: props?.parentClientId || props?.clientId,
        isJsonReturnObject: false,
        search,
        businessName: props?.businessName,
        clientProductsId: productId || (props?.editLeadData && props?.editLeadData?.clientProductsId),
      };

      service
        .getRolodexContactsData(payload)
        .then((res: any) => {
          setLeadData(res.data);
        })
        .catch((err: any) => { });
    }
    else {
      let payload = {
        screen: "ProspectTR",
        sections: "getClientContactsbyOrgId",
        parentClientId: props?.parentClientId || props?.clientId,
        orgId: context.bankuserDetails?.organization.orgId,
        isJsonReturnObject: false,
        businessName: props?.businessName,

        search,
      };
      service
        .getLeadsData(payload)
        .then((res: any) => {
          setLeadData(res.data?.map((c: any) => { c.phoneNumber = c.phoneNumber || c.phone; return c; }));
        })
        .catch((err: any) => { });
    }
  };
  return (
    <form onSubmit={props.handleSubmit(handleSelectContact)}>
      <Container>
        <Col md="" className="existingContact">
          <AddNewContactCards
            leadData={leadData}
            msgButton={false}
            addNewContactBtn={false}
            selectBtn={true}
            searchItem={handleSearch}
            placeholder={"Search"}
            clientContactId={handleSelectContact}
            clientId={props?.clientId}
            productId={props?.productId}
            parentClientId={props?.editLeadData && props?.editLeadData.parentClientId}
            clientProductsContactMappingId={(props?.editLeadData && props?.editLeadData.clientProductsContactMappingId) || props?.clientProductsContactMappingId}
            presentLead={props?.createLeadValues}
            getAllContacts={getAddContact}
          />
        </Col>
      </Container>
      {/* <button className="selectButton" type="submit">
        Select
      </button> */}
    </form>
  );
};

const mapStateToProps = (state: any, props: any) => {
  return {
    initialValues: {
      // contactName: stateNames,
    },
    formValues: getFormValues("SelectExistingContact")(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "SelectExistingContact", // a unique identifier for this form
    enableReinitialize: true,
  })(SelectExistingContact)
);
